import {
  AMODULO_ADMAPPCLI,
  AMODULO_CRM,
  AMODULO_ESTOQUE,
  AMODULO_FINANCAS,
  AMODULO_FRONT,
  AMODULO_FROTAS,
  AMODULO_GERENCIAL,
  AMODULO_PARTNER,
  AMODULO_SISAREPASSENGER
} from 'consts';
import React from 'react';
import Sidebar from '../Sidebar';
import SideBarCRM from '../SideBarCRM';
import SideBarAppCli from '../SideBarAppCli';
import SideBarFrotas from '../SideBarFrotas';
import SideBarEstoque from '../SideBarEstoque';
import SideBarPartner from '../SideBarPartner';
import { useLocation } from 'react-router-dom';
import SideBarFinancas from '../SideBarFinancas';
import SideBarAdmAppCli from '../SideBarAdmAppCli';
import SideBarGerencial from '../SideBarGerencial';
import SideBarAdmPartner from '../SideBarAdmPartner';

const ChosenBar = (props) => {
  const { onClose, variant, modulo, open } = props;
  const location = useLocation();

  let componenteRenderizado;

  switch (parseInt(modulo, 10)) {
    case AMODULO_FRONT:
      componenteRenderizado = (
        <Sidebar
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );

      break;
    case AMODULO_FINANCAS:
      componenteRenderizado = (
        <SideBarFinancas
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );

      break;
    case AMODULO_GERENCIAL:
      componenteRenderizado = (
        <SideBarGerencial
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );

      break;
    case AMODULO_SISAREPASSENGER:
      componenteRenderizado = (
        <SideBarAppCli
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );

      break;
    case AMODULO_ADMAPPCLI:
      componenteRenderizado = (
        <SideBarAdmAppCli
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );

      break;
    case AMODULO_FROTAS:
      componenteRenderizado = (
        <SideBarFrotas
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );

      break;
    case AMODULO_CRM:
      componenteRenderizado = (
        <SideBarCRM
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );

      break;
    case AMODULO_ESTOQUE:
      componenteRenderizado = (
        <SideBarEstoque
          onClose={onClose}
          open={open}
          variant={variant}
        />
      );

      break;
    case AMODULO_PARTNER:
      if (location.pathname.startsWith('/admpartner')) {
        componenteRenderizado = (
          <SideBarAdmPartner
            onClose={onClose}
            open={open}
            variant={variant}
          />
        );
      } else if (location.pathname.startsWith('/partner')) {
        componenteRenderizado = (
          <SideBarPartner
            onClose={onClose}
            open={open}
            variant={variant}
          />
        );
      } else {
        componenteRenderizado = <div>menu partner não identificado</div>;
      }

      break;
    default:
      componenteRenderizado = <div>nenhum menu selecionado</div>;
      break;
  };

  return <div>{componenteRenderizado}</div>;
};

export default ChosenBar;